"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTranslation = void 0;
exports.withTranslation = {
  en: {
    ca: {
      stateProvince: "Province",
      zipPostal: "Postal Code"
    },
    mx: {
      zipPostal: "Postal Code",
      stateProvince: "Province"
    },
    us: {
      stateProvince: "State",
      country: "Country",
      streetAddressOne: "Street Address",
      city: "City",
      zipPostal: "Zip"
    }
  },
  fr: {
    ca: {
      stateProvince: "Province"
    },
    mx: {
      stateProvince: "Province"
    },
    us: {
      stateProvince: "État",
      country: "Pays",
      streetAddressOne: "Adresse de la rue",
      city: "Ville",
      zipPostal: "Code Postal"
    }
  },
  es: {
    mx: {
      stateProvince: "Provincia"
    },
    ca: {
      stateProvince: "Provincia"
    },
    us: {
      stateProvince: "Estado",
      country: "País",
      streetAddressOne: "Dirección",
      city: "Cuidad",
      zipPostal: "Código postal"
    }
  }
};